import type { FC } from "react";
import React from "react";

import {
    LeftIcon,
    RightIcon,
} from "../../../../../ButtonInline/components/Icon/ButtonInlineIcon";
import { createDisplayNameForButtonCellSchevronElement } from "../../../utils/getDisplayName";

import type { IButtonInlineIcon } from "../../../../../ButtonInline/types";

export const ButtonInlineLeftIcon: FC<IButtonInlineIcon> = (props) => {
    // eslint-disable-next-line ok-custom-rules/check-attribute
    return <LeftIcon {...props} />;
};

ButtonInlineLeftIcon.displayName =
    createDisplayNameForButtonCellSchevronElement("ButtonInlineLeftIcon");

export const ButtonInlineRightIcon: FC<IButtonInlineIcon> = (props) => {
    // eslint-disable-next-line ok-custom-rules/check-attribute
    return <RightIcon {...props} />;
};

ButtonInlineRightIcon.displayName =
    createDisplayNameForButtonCellSchevronElement("ButtonInlineRightIcon");
